import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "subLabel", "info", "LeadingIcon", "renderLeadingIcon", "TrailingIcon", "renderTrailingIcon", "helperText", "autoFocus", "className", "inputClassName", "tooltip", "full", "sizeType", "error", "disabled", "labelProps", "inputElProps"];
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { BaseInput } from "../BaseInput";
import { BaseInputHelperText, BaseInputInfo, BaseInputLabelText } from "../shared";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated Use the InputField component instead.
 */
export var TextField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    subLabel = _ref.subLabel,
    info = _ref.info,
    LeadingIcon = _ref.LeadingIcon,
    renderLeadingIcon = _ref.renderLeadingIcon,
    TrailingIcon = _ref.TrailingIcon,
    renderTrailingIcon = _ref.renderTrailingIcon,
    helperText = _ref.helperText,
    autoFocus = _ref.autoFocus,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    tooltip = _ref.tooltip,
    full = _ref.full,
    _ref$sizeType = _ref.sizeType,
    sizeType = _ref$sizeType === void 0 ? 'large' : _ref$sizeType,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$labelProps = _ref.labelProps,
    labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
    _ref$inputElProps = _ref.inputElProps,
    inputElProps = _ref$inputElProps === void 0 ? {} : _ref$inputElProps,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var errorMessageId = inputElProps.name ? "".concat(inputElProps.name, "-error") : undefined;
  var inputElPropsWithName = _objectSpread({
    'aria-errormessage': errorMessageId,
    'aria-invalid': error
  }, inputElProps);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(className, full ? 'tw-w-full' : 'tw-w-28'),
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col",
      children: [/*#__PURE__*/_jsx("label", _objectSpread(_objectSpread({}, labelProps), {}, {
        className: clsx(labelProps.className, {
          'tw-cursor-not-allowed': disabled
        }),
        children: label && /*#__PURE__*/_jsx(BaseInputLabelText, {
          label: label,
          disabled: disabled,
          tooltip: tooltip,
          className: "tw-mb-0.8",
          sizeType: sizeType
        })
      })), subLabel && /*#__PURE__*/_jsx("span", {
        className: "tw-mb-0.8",
        children: subLabel
      }), info && /*#__PURE__*/_jsx(BaseInputInfo, {
        info: info,
        disabled: disabled,
        className: "tw-mb-0.8"
      }), /*#__PURE__*/_jsx(BaseInput, _objectSpread({
        full: full,
        LeadingIcon: LeadingIcon,
        renderLeadingIcon: renderLeadingIcon,
        TrailingIcon: TrailingIcon,
        renderTrailingIcon: renderTrailingIcon,
        error: error,
        disabled: disabled,
        sizeType: sizeType,
        className: inputClassName
        // it's ok to disable this rule because this component live in an ui library
        // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autoFocus,
        ref: ref,
        label: label,
        inputElProps: inputElPropsWithName
      }, inputProps)), helperText && /*#__PURE__*/_jsx("div", {
        className: "tw-mt-0.8",
        id: errorMessageId,
        children: /*#__PURE__*/_jsx(BaseInputHelperText, {
          text: helperText,
          error: error
        })
      })]
    })
  });
});
TextField.displayName = 'TextField';
export default TextField;